var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoodCleaning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70701 17.293C6.31601 16.902 5.68401 16.902 5.29301 17.293L4.29301 18.293C3.90201 18.684 3.90201 19.316 4.29301 19.707C4.39801 19.812 4.52201 19.884 4.65301 19.933L4.29301 20.293C3.90201 20.684 3.90201 21.316 4.29301 21.707C4.48801 21.902 4.74401 22 5.00001 22C5.25601 22 5.51201 21.902 5.70701 21.707L6.70701 20.707C7.09801 20.316 7.09801 19.684 6.70701 19.293C6.60201 19.188 6.47801 19.116 6.34701 19.067L6.70701 18.707C7.09801 18.316 7.09801 17.684 6.70701 17.293Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.347 19.067L18.707 18.707C19.098 18.316 19.098 17.684 18.707 17.293C18.316 16.902 17.684 16.902 17.293 17.293L16.293 18.293C15.902 18.684 15.902 19.316 16.293 19.707C16.398 19.812 16.522 19.884 16.653 19.933L16.293 20.293C15.902 20.684 15.902 21.316 16.293 21.707C16.488 21.902 16.744 22 17 22C17.256 22 17.512 21.902 17.707 21.707L18.707 20.707C19.098 20.316 19.098 19.684 18.707 19.293C18.602 19.188 18.478 19.116 18.347 19.067Z",
    fill: "#313131"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.707 17.293C12.316 16.902 11.684 16.902 11.293 17.293L10.293 18.293C9.90201 18.684 9.90201 19.316 10.293 19.707C10.398 19.812 10.522 19.884 10.653 19.933L10.293 20.293C9.90201 20.684 9.90201 21.316 10.293 21.707C10.488 21.902 10.744 22 11 22C11.256 22 11.512 21.902 11.707 21.707L12.707 20.707C13.098 20.316 13.098 19.684 12.707 19.293C12.602 19.188 12.478 19.116 12.347 19.067L12.707 18.707C13.098 18.316 13.098 17.684 12.707 17.293Z",
    fill: "#313131"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7H8V4C8 2.895 8.895 2 10 2H14C15.105 2 16 2.895 16 4V7Z",
    fill: "#313131"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7L3 13H21.043L16 7H8Z",
    fill: "#313131"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 15H3.5C2.672 15 2 14.328 2 13.5C2 12.672 2.672 12 3.5 12H20.5C21.328 12 22 12.672 22 13.5C22 14.328 21.328 15 20.5 15Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoodCleaning);
export default __webpack_public_path__ + "static/media/hood-cleaning.4ca4163209ec904d30cf06c6b3d7dcd5.svg";
export { ForwardRef as ReactComponent };